// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3FTZX","textarea":"styles_textarea__25osS"};